import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.scss";

import Hero from "./components/Hero";
import Profile from "./components/Profile";
import Certifications from "./components/Certifications";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Career from "./components/Career";
import Footer from "./components/Footer";
import SideNav from "./components/SideNav";
import BinnieWidget from "./components/BinnieWidget";

// 관리자/게스트 페이지는 각각 별도 청크로 분리 —
// 메인 사이트 방문자는 다운로드하지 않고, 게스트 청크에는 프로필·프로젝트 데이터가 없다.
const Admin = lazy(() => import("./admin/Admin"));
const Guest = lazy(() => import("./guest/Guest"));

// /admin·/guest (또는 #/admin·#/guest) 진입 시 해당 페이지 렌더.
// 정적 호스팅에서 직접 접근은 vercel.json rewrite로 처리, 해시 라우트는 어디서든 동작.
function getRoute() {
  const path = window.location.pathname.replace(/\/+$/, "");
  const hash = window.location.hash;
  if (path === "/admin" || hash.startsWith("#/admin")) return "admin";
  if (path === "/guest" || hash.startsWith("#/guest")) return "guest";
  return null;
}

// Binnie 챗봇 API (appeal-me.com). 공개 프로필 + 공개 등급 Notion 노트만 답한다.
const BINNIE_ENDPOINT = process.env.REACT_APP_BINNIE_ENDPOINT || "https://appeal-me.com/api/public/chat";

// 참고 디자인(seungyong.co.kr)과 같은 단일 스크롤 구성.
// Hero → Profile → Certificates → Projects → Skills → Career
function App() {
  const [route, setRoute] = useState(getRoute);

  useEffect(() => {
    const onHashChange = () => setRoute(getRoute());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  if (route === "admin") {
    return (
      <Suspense fallback={null}>
        <Admin />
      </Suspense>
    );
  }

  if (route === "guest") {
    return (
      <Suspense fallback={null}>
        <Guest />
      </Suspense>
    );
  }

  return (
    <div className="App">
      <SideNav />

      <main>
        <Hero />
        <Profile />
        <Certifications />
        <Projects />
        <Skills />
        <Career />
      </main>

      <Footer />
      <BinnieWidget endpoint={BINNIE_ENDPOINT} />
    </div>
  );
}

export default App;
